import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Help.module.sass";
import Icon from "../../Icon";
import banner from "../../../i11/Banner";
import TextInput from "../../TextInput";
import Dropdown from "../../Dropdown";
import ImageInput from "../../ImageInput";
import Loader from "../../Loader";
import { useUser } from "../../../context";
import { UseApi } from "../../../hooks/use-api";
import { AddBanner } from "../../../Services/lib/admin";
import { InputController } from "../../../hooks/input-controller";
import SearchProduct from "../../../screens/Banner/searchProduct";
import EditBanner from "../../../screens/Banner/edit";
const type = ["Full-width", "Half-width"];
const linksTo1 = ["Community marketplace", "Token Store", "Product"];
const linksTo2 = ["-", "Collections", "Categories"];

const Help = ({ className, visible, setVisible, onClose, props, editItem }) => {
	const { linksTo3, getBanner } = props;
	const { locale } = useUser();

	const handleClose = (close) => {
		if (editItem && !close) getBanner();
		onClose();
		setVisible(false);
	};

	return (
		<>
			<div className={cn(styles.help, className, { [styles.active]: visible })}>
				<div className={styles.head}>
					<Icon name={editItem ? "edit" : "plus"} size="16" />
					{banner[locale][editItem ? "edit_banner" : "create_banner"]}
					<button className={styles.close} onClick={() => handleClose(true)}>
						<Icon name="close" size="24" />
					</button>
				</div>
				{!editItem && <CreateBanner {...props} />}
				{editItem && (
					<EditBanner
						linksTo3={linksTo3}
						initial={editItem}
						onClose={handleClose}
					/>
				)}
			</div>
			<div
				className={cn(styles.overlay, { [styles.active]: visible })}
				onClick={() => setVisible(false)}
			></div>
		</>
	);
};

const CreateBanner = ({ getBanner, linksTo3 }) => {
	const { locale } = useUser();
	const [{ isLoading }, create] = UseApi({
		service: AddBanner,
	});

	const [val, setVal] = useState({
		name: "",
		_id: "",
	});

	const [body, setBody] = useState({
		title: "",
		description: "",
		image: "",
		image_thumb: [],
		prior: 100,
		url: "",
		banner_size: type[0],
	});
	const title = InputController("title", setBody);
	const prior = InputController("prior", setBody);
	const [Type, setType] = useState(type[0]);
	const [link1, setLink1] = useState(linksTo1[0]);
	const [link2, setLink2] = useState(linksTo2[0]);
	const [link3, setLink3] = useState(linksTo3[linksTo2[0]]?.vals[0] || "");
	const [imgL, setL] = useState(false);

	const onSubmit = async (e) => {
		e.preventDefault();
		if (imgL) {
			// ToastEmitter({
			// 	msg: "Image is uploading, please wait",
			// 	type: "info",
			// });
		} else {
			const tmp = { ...body };
			tmp.image_thumb = tmp.image.image_list;
			tmp.image = tmp.image.core_image_url;
			tmp.banner_size = Type;
			if (link1 === "Community marketplace") {
				tmp.url = "/marketplace";
			} else if (link1 === "Product") {
				tmp.url = `/template/${val._id}`;
			} else if (link2 === "-") {
				tmp.url = "/collections";
			} else {
				tmp.url = `/${link2.toLowerCase()}/${link3}`;
			}
			const res = await create(tmp);
			if (res) {
				document.getElementById("create-banner-form").reset();
				setBody({
					title: "",
					description: "",
					image: "",
					prior: 100,
					image_thumb: [],
					url: "",
					banner_size: type[0],
				});
				setLink1(linksTo1[0]);
				setLink2(linksTo2[0]);

				getBanner();
			}
		}
	};

	const HandleChange = (e) => {
		setBody((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	useEffect(() => {
		setLink3(linksTo3[link2]?.vals[0] || "");
	}, [link2]);

	return (
		// <Card title={banner[locale].create_banner} classTitle="title-purple">
		<form id="create-banner-form" onSubmit={onSubmit} className={styles.form}>
			<TextInput
				className={styles.field}
				label={banner[locale].banner_text}
				name="title"
				type="text"
				required
				{...title}
			/>
			<Dropdown
				className={cn(styles.field, styles.Dropdown)}
				label={banner[locale].size}
				value={Type}
				setValue={setType}
				dictionary={banner[locale].typeDic}
				options={type}
			/>
			<ImageInput
				aspect_ratio={Type === type[0] ? 135 / 43 : 135 / 86}
				where="BANNERS"
				callBack={HandleChange}
				className={styles.field}
				label={banner[locale].banner_image}
				required
				setL={setL}
				isLoadingForm={isLoading}
			/>
			<div className={styles.multiDropDown}>
				<Dropdown
					className={cn(styles.field, styles.Dropdown)}
					label={banner[locale].links_to}
					value={link1}
					setValue={setLink1}
					dictionary={banner[locale].linksTo1Dic}
					options={linksTo1}
				/>
				{link1 === "Token Store" && (
					<Dropdown
						className={cn(styles.field, styles.Dropdown)}
						value={link2}
						setValue={setLink2}
						dictionary={banner[locale].linksTo2Dic}
						options={linksTo2}
					/>
				)}
				{link1 === "Product" && <SearchProduct val={val} setVal={setVal} />}
			</div>
			{link1 === "Token Store" && link2 !== "-" && (
				<Dropdown
					className={cn(styles.field, styles.Dropdown)}
					value={link3}
					setValue={setLink3}
					options={linksTo3[link2]?.vals}
					dictionary={linksTo3[link2]?.dic}
				/>
			)}
			<TextInput
				className={styles.field}
				label={banner[locale].order}
				name="Priority"
				type="number"
				required
				{...prior}
			/>

			<div className={styles.field}>
				<button className={cn("button", { disabled: isLoading })}>
					{isLoading && <Loader />}
					{banner[locale].save}
				</button>
			</div>
		</form>
		// </Card>
	);
};
export default Help;
